module.exports = __webpack_public_path__ + "static/media/ItemsIsItemsFOV.b0130427.png";